import { Box, AppBar as MUIAppBar, Toolbar, useTheme } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

import { GroundlightIcon } from "assets/icons";
import { getConfig } from "config/config";
import { COMPANY_INFO } from "config/constants";
import { RouteSpec } from "routing/routeSpecs";
import { User } from "types/users";

import AccountMenu from "./components/AccountMenu";
import NavTabs from "./components/NavTabs";
import SubNavTabs from "./components/SubNavTabs";
import TemporaryDrawer from "./components/TemporaryDrawer";


const { REACT_APP_BASE_PREFIX } = getConfig();

interface AppBarProps {
  user?: User;
  isUserDisabled?: boolean;
  routeSpec?: RouteSpec;
}

const toolbarSx = {
  display: "flex",
  height: "50px",
  px: { xs: "10px", sm: "20px", md: "30px" },
};

export function AppBar(props: AppBarProps) {
  const { user, routeSpec, isUserDisabled = false } = props;
  const userIsAvaliable = user && !isUserDisabled;
  const theme = useTheme();

  return (
    <Box>
      {/* First layer */}
      <MUIAppBar position="sticky">
        <Box
          className="bg-axon-dark"
          sx={{
            ...toolbarSx,
            alignItems: "center",
          }}
        >
          <Link to={`${REACT_APP_BASE_PREFIX}/`} className="text-white text-xl px-4 no-underline flex items-center">
            <GroundlightIcon color={theme.palette.axon.main} />
            <Box component="span" sx={{ ml: "10px" }} className="text-axon">
              {COMPANY_INFO.name}
            </Box>
          </Link>
          {userIsAvaliable && (
            <Box className="flex grow justify-end">
              <AccountMenu user={user} />
            </Box>
          )}
        </Box>

        {/* Second layer */}
        {userIsAvaliable && (
          <Toolbar className="bg-axon-medium min-h-[50px]" sx={toolbarSx}>
            <TemporaryDrawer user={user} />
            <NavTabs user={user} routeSpec={routeSpec} />
          </Toolbar>
        )}
      </MUIAppBar>

      {/* Third layer */}
      {userIsAvaliable && routeSpec?.tab && routeSpec?.subTab && (
        <SubNavTabs routeSpec={routeSpec} userInfo={user} />
      )}
    </Box>
  );
}
